import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import DexpTrackingKeys from '../../../constants/locale/key/DexpTracking'

const DexpTrackingTranslationText = () => {
    const { translate } = useTranslation([
        Namespace.DEXP_TRACKING
    ])

    const translateKey = (key) => translate(Namespace.DEXP_TRACKING, key)

    return {
        pleaseEnterSearchNumber: translateKey(DexpTrackingKeys.PLEASE_ENTER_SEARCH_NUMBER),
        retrieveSuccessMessage: translateKey(DexpTrackingKeys.RETRIEVE_SUCCESS_MESSAGE),
        failedToRetrieveErrorMessage: translateKey(DexpTrackingKeys.FAILED_TO_RETRIEVE_ERROR_MESSAGE),
        failedToTrackErrorMessage: translateKey(DexpTrackingKeys.FAILED_TO_TRACK_ERROR_MESSAGE),
        containerNo: translateKey(DexpTrackingKeys.CONTAINER_NO),
        ccn: translateKey(DexpTrackingKeys.CCN),
        noRecordFound: translateKey(DexpTrackingKeys.NO_RECORD_FOUND),
        viewing: translateKey(DexpTrackingKeys.VIEWING),
        containerHistory: translateKey(DexpTrackingKeys.CONTAINER_HISTORY),
        forCustomsStatusPleaseSearchBy: translateKey(DexpTrackingKeys.FOR_CUSTOMS_STATUS_PLEASE_SEARCH_BY),
        cntr: translateKey(DexpTrackingKeys.CNTR),
        vessel: translateKey(DexpTrackingKeys.VESSEL),
        daysAtPort: translateKey(DexpTrackingKeys.DAYS_AT_PORT),
        title: translateKey(DexpTrackingKeys.TITLE),
        loginButton: translateKey(DexpTrackingKeys.LOGIN_BUTTON),
        registerButton: translateKey(DexpTrackingKeys.REGISTER_BUTTON),
        complianceSummaryTitle: translateKey(DexpTrackingKeys.COMPLIANCE_SUMMARY_TITLE),
        masterLevelTitle: translateKey(DexpTrackingKeys.MASTER_LEVEL_TITLE),
        primaryACIManifests: translateKey(DexpTrackingKeys.PRIMARY_ACI_MANIFESTS),
        primaryACIOceanManifest: translateKey(DexpTrackingKeys.PRIMARY_ACI_OCEAN_MANIFEST),
        note: translateKey(DexpTrackingKeys.NOTE),
        houseLevelTitle: translateKey(DexpTrackingKeys.HOUSE_LEVEL_TITLE),
        ehbls: translateKey(DexpTrackingKeys.EHBLS),
        released: translateKey(DexpTrackingKeys.RELEASED),
        accepted: translateKey(DexpTrackingKeys.ACCEPTED),
        acceptedCBSA: translateKey(DexpTrackingKeys.ACCEPTED_CBSA),
        submitted: translateKey(DexpTrackingKeys.SUBMITTED),
        held: translateKey(DexpTrackingKeys.HELD),
        rejected: translateKey(DexpTrackingKeys.REJECTED),
        dataNotAvailable: translateKey(DexpTrackingKeys.DATA_NOT_AVAILABLE),
        timelineTitle: translateKey(DexpTrackingKeys.TIMELINE_TITLE),
        customsHold: translateKey(DexpTrackingKeys.CUSTOMS_HOLD),
        storageChargeLastFreeDay: translateKey(DexpTrackingKeys.STORAGE_CHARGE_LAST_FREE_DAY)
    }
}

export default DexpTrackingTranslationText